module.exports = __webpack_public_path__ + "static/media/cynthia-win.5a3c1cf8.png";